import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=bc9f0850&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9f0850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc9f0850')) {
      api.createRecord('bc9f0850', component.options)
    } else {
      api.reload('bc9f0850', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=bc9f0850&scoped=true&", function () {
      api.rerender('bc9f0850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zea4E1k6xWmL/JS/comp/Accordion.vue"
export default component.exports